import { useQuery } from '@tanstack/react-query'
import { useMergeFields } from '@web/components/page-components/Text/MergeTags/MergeTag'
import { countUpTo } from '@web/components/page-components/Text/MergeTags/utils'
import { usePageStore } from 'apps/fe-donation/libs/hooks/usePageStore'
import { toSearchParams } from 'apps/fe-donation/utils'
import { useEffect, useState } from 'react'

const PageAmountRaisedHandler = () => {
  const shouldProcess = useMergeFields((state) => state.postProcessTags.has('Page.AmountRaised'))
  const campaignId = usePageStore((state) => state.campaignId)
  const isLiveMode = usePageStore((state) => state.isLiveMode)
  const pageBucketId = usePageStore((state) => state.pageBucketId)
  const progressIds = usePageStore((state) => state.elementSettings?.progressBar?.pageIds ?? [])
  const defaultPageId = usePageStore((state) => [state.pageId ?? ''])
  const [prevAmount, setPrevAmount] = useState<number>(0)

  const { data: amount = 0 } = useQuery({
    queryKey: ['progressBarAmount', campaignId, progressIds],
    queryFn: async () => {
      const amount = await fetch(
        `/api/progress-bar?${toSearchParams({
          campaignId,
          pageIds: pageBucketId ? progressIds.map((x) => x ?? '') : defaultPageId,
          isLiveMode,
        })}`,
      )
        .then((res) => res.json())
        .then((data) => data.amount)
        .catch(() => 0)
      return amount
    },
    refetchOnMount: false,
    enabled: !!campaignId && shouldProcess,
  })

  // setTimeouts to beat out first render
  useEffect(() => {
    if (!shouldProcess) {
      return
    }

    if (!amount) {
      setTimeout(() => {
        const elements = document.querySelectorAll('[data-merge-tag-value="Page.AmountRaised"]')
        elements.forEach((element) => {
          element.textContent = '0'
        })
      }, 1)
      return
    }

    const elements = document.querySelectorAll('[data-merge-tag-value="Page.AmountRaised"]')
    useMergeFields.getState().setMergeField('Page.AmountRaised', amount.toString())

    setTimeout(() => {
      elements.forEach((element) => {
        countUpTo(element, amount, amount.toString().length * 0.3, prevAmount)
      })

      setPrevAmount(amount)
    }, 1)
  }, [amount, shouldProcess])

  return null
}

export default PageAmountRaisedHandler
